import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionLearnFirstPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-not-alone')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionLearnFirst.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionLearnFirst.properWatering'),
          value: 'proper_watering',
        },
        {
          text: t('pages.onboarding.questionLearnFirst.lightRequirements'),
          value: 'light_requirements',
        },
        {
          text: t('pages.onboarding.questionLearnFirst.soilFertilizing'),
          value: 'soil_fertilizing',
        },
        {
          text: t('pages.onboarding.questionLearnFirst.plantHealth'),
          value: 'plant_health',
        },
        {
          text: t('pages.onboarding.questionLearnFirst.pruningPropagation'),
          value: 'pruning_propagation',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
